import React, { Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '@material-ui/core/styles';
import { Switch, Route } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { useSelector } from 'react-redux';
import { LinearProgress } from '@material-ui/core';

import '@maptiler/sdk/dist/maptiler-sdk.css';

import theme from './theme';
import { LocalizationProvider } from './LocalizationProvider';
import { SERVER_NAME } from './config/constant';
import { empty, getToken } from './helpers/untils';

import LoginForm from './components/registration/LoginForm';
import { AuthorizedLayout } from './layout/AuthorizedLayout';
import WebPageFooter from './WebPageFooter';
import SocketController from './SocketController';
import ZendeskCloseButton from './components/ZendeskCloseButton';
import GpsMainSite from './GpsMainSite';

import { publicRoutes } from './routes/publicRoutes';
import { authorizedRoutes } from './routes/authorizedRoutes';
import { adminRoutes } from './routes/adminRoutes';

const AuthorizedApp = () => (
  <AuthorizedLayout>
    <Suspense fallback={<LinearProgress />}>
      <Switch>{[...authorizedRoutes, ...adminRoutes]}</Switch>
    </Suspense>
  </AuthorizedLayout>
);

const MoovetraxApp = () => {
  const initialized = useSelector((state) => !!state.session.server);
  const token = getToken();

  return (
    <ThemeProvider theme={theme}>
      <WebPageFooter />
      <CssBaseline />
      <SocketController />
      <Switch>
        {publicRoutes}
        <Route>
          {empty(token)
            ? <LoginForm />
            : !initialized
              ? <LinearProgress />
              : <AuthorizedApp />
          }
        </Route>
      </Switch>
    </ThemeProvider>
  );
};

const GpsApp = () => (
  <ThemeProvider theme={theme}>
    <WebPageFooter />
    <CssBaseline />
    <Switch>
      <Route path="/" component={GpsMainSite} />
    </Switch>
  </ThemeProvider>
);

const App = () => (
  <HelmetProvider>
    <LocalizationProvider>
      {SERVER_NAME === 'moovetrax.com' && <MoovetraxApp />}
      {SERVER_NAME === 'gps.moovetrax.com' && <GpsApp />}
      <ZendeskCloseButton />
    </LocalizationProvider>
  </HelmetProvider>
);

export default App;
